/** Query key factories for all student queries */

export const dashboardKeys = {
  all: () => ['student', 'dashboard'] as const,
  profile: () => [...dashboardKeys.all(), 'profile'] as const,
  stats: () => [...dashboardKeys.all(), 'stats'] as const,
  quickStats: () => [...dashboardKeys.all(), 'quick-stats'] as const,
  overallProgress: () => [...dashboardKeys.all(), 'overall-progress'] as const,
  continueWatching: () => [...dashboardKeys.all(), 'continue-watching'] as const,
  currentModule: () => [...dashboardKeys.all(), 'current-module'] as const,
  moduleLessons: (moduleId: string) => [...dashboardKeys.all(), 'module-lessons', moduleId] as const,
  enrolledCourses: (params?: Record<string, unknown>) => [...dashboardKeys.all(), 'enrolled-courses', params] as const,
  recommendedCourses: (params?: Record<string, unknown>) => [...dashboardKeys.all(), 'recommended-courses', params] as const,
  liveEvents: () => [...dashboardKeys.all(), 'live-events'] as const,
  menuItems: () => [...dashboardKeys.all(), 'menu-items'] as const,
}

export const catalogKeys = {
  all: () => ['student', 'catalog'] as const,
  categories: (params?: Record<string, unknown>) => [...catalogKeys.all(), 'categories', params] as const,
  courses: (categoryId: string) => [...catalogKeys.all(), 'courses', categoryId] as const,
  courseDetail: (id: string) => [...catalogKeys.all(), 'course', id] as const,
  search: (params?: Record<string, unknown>) => [...catalogKeys.all(), 'search', params] as const,
  resolve: (slug: string) => [...catalogKeys.all(), 'resolve', slug] as const,
}

export const lessonKeys = {
  all: () => ['student', 'lessons'] as const,
  resolve: (menu: string, program?: string, episode?: string) => [...lessonKeys.all(), 'resolve', menu, program, episode] as const,
  detail: (id: string) => [...lessonKeys.all(), id] as const,
  context: (id: string) => [...lessonKeys.all(), id, 'context'] as const,
  courseTree: (id: string) => [...lessonKeys.all(), id, 'course-tree'] as const,
  progress: (id: string) => [...lessonKeys.all(), id, 'progress'] as const,
  courseProgress: (id: string) => [...lessonKeys.all(), id, 'course-progress'] as const,
  resources: (id: string) => [...lessonKeys.all(), id, 'resources'] as const,
  comments: (id: string, params?: Record<string, unknown>) => [...lessonKeys.all(), id, 'comments', params] as const,
}

export const commentKeys = {
  all: () => ['student', 'comments'] as const,
  list: (entityId: string, params?: Record<string, unknown>) => [...commentKeys.all(), entityId, params] as const,
}

export const saveKeys = {
  all: () => ['student', 'saves'] as const,
}

export const xpKeys = {
  all: () => ['student', 'xp'] as const,
  breakdown: () => [...xpKeys.all(), 'breakdown'] as const,
}

export const achievementKeys = {
  all: () => ['student', 'achievements'] as const,
  list: () => [...achievementKeys.all(), 'list'] as const,
  summary: () => [...achievementKeys.all(), 'summary'] as const,
}

export const leaderboardKeys = {
  all: () => ['student', 'leaderboard'] as const,
  list: (params?: Record<string, unknown>) => [...leaderboardKeys.all(), params] as const,
}

export const communityKeys = {
  all: () => ['student', 'community'] as const,
  recent: () => [...communityKeys.all(), 'recent'] as const,
  newCount: () => [...communityKeys.all(), 'new-count'] as const,
  channels: () => [...communityKeys.all(), 'channels'] as const,
  channelPosts: (slug: string) => [...communityKeys.all(), 'channel-posts', slug] as const,
}

export const billingKeys = {
  all: () => ['student', 'billing'] as const,
  paymentMethods: () => [...billingKeys.all(), 'payment-methods'] as const,
  orders: () => [...billingKeys.all(), 'orders'] as const,
  subscriptions: () => [...billingKeys.all(), 'subscriptions'] as const,
}
